<script setup>

</script>

<template>
    <svg width="19" height="19" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M3.63695 7.05328L8.8241 13.1066C8.90771 13.2041 9.01142 13.2824 9.12813 13.336C9.24484 13.3897 9.37177 13.4175 9.50023 13.4175C9.62868 13.4175 9.75562 13.3897 9.87233 13.336C9.98903 13.2824 10.0927 13.2041 10.1764 13.1066L15.3635 7.05328C15.8585 6.47549 15.4481 5.58301 14.6874 5.58301H4.3116C3.55086 5.58301 3.14043 6.47549 3.63695 7.05328Z"
            fill="#FFB700"/>
    </svg>
</template>

<style scoped>

</style>
